import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-blue-600 text-white p-6">
            <h1 className="text-3xl font-bold text-center">Privacy Policy</h1>
            <p className="text-blue-100 text-center mt-2">Cosmino Privacy App</p>
          </div>
          
          <div className="p-8 space-y-8">
            {/* Introduction */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Privacy Policy</h2>
              <p className="text-gray-600 leading-relaxed">
                This Privacy Policy describes how Cosmino Privacy ("we", "our", or "us") handles information when you use our application. 
                We are committed to protecting your privacy and ensuring you have a positive experience on our platform.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                By using our application, you agree to the collection and use of information in accordance with this policy.
              </p>
            </section>

            {/* Information Collection and Use */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Information Collection and Use</h2>
              <p className="text-gray-600 leading-relaxed">
                We want to inform you that our application does not collect, store, or process any personal information from our users. 
                Our application is designed to function without requiring any personal data such as names, email addresses, 
                phone numbers, or other identifying information.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                You can enjoy all features of our app without providing any personal information whatsoever.
              </p>
            </section>

            {/* Log Data */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Log Data</h2>
              <p className="text-gray-600 leading-relaxed">
                In case of errors or technical issues in the app, we may collect basic device information through third-party 
                services. This log data may include information such as your device's operating system, 
                app version, the time and date of your use of the service, and other diagnostic data.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                This information is used solely for the purpose of identifying and fixing technical issues to improve our service.
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cookies</h2>
              <p className="text-gray-600 leading-relaxed">
                Our application does not use cookies or similar tracking technologies. We do not store any information on your device 
                that could be used to track your browsing behavior or personal preferences.
              </p>
            </section>

            {/* Third-Party Services */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Third-Party Services</h2>
              <p className="text-gray-600 leading-relaxed">
                Our application may use third-party services that may collect information used to identify you. 
                These services are used solely for app functionality and improvement purposes.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                We have no control over and assume no responsibility for the content, privacy policies, or practices of any 
                third-party sites or services.
              </p>
            </section>

            {/* Security */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We value your trust and strive to use commercially acceptable means of protecting any data that may be processed. 
                Our application is built using industry-standard security practices and frameworks. However, remember that no method 
                of transmission over the internet or method of electronic storage is 100% secure.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Since we don't collect personal information, the risk to your privacy is minimal.
              </p>
            </section>

            {/* Children's Privacy */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Children's Privacy</h2>
              <p className="text-gray-600 leading-relaxed">
                Our application does not address anyone under the age of 13. We do not knowingly collect personally 
                identifiable information from children under 13. Since we don't collect any personal information at all, 
                this application is safe for users of all ages.
              </p>
            </section>

            {/* Data Retention */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Data Retention</h2>
              <p className="text-gray-600 leading-relaxed">
                Since we do not collect or store any personal data, there is no personal information to retain or delete. 
                Any technical logs that may be generated are automatically purged according to standard system maintenance schedules.
              </p>
            </section>

            {/* Changes to This Privacy Policy */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Changes to this Policy</h2>
              <p className="text-gray-600 leading-relaxed">
                We may update this Privacy Policy from time to time. Changes will be posted here with the "Last updated" date.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Changes to this Privacy Policy are effective when they are posted on this page.
              </p>
            </section>

            {/* Contact Us */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">
                If you have any questions or concerns about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                <p className="text-blue-800 font-medium">
                  📧 Email: <a href="mailto:cosmino.space@gmail.com" className="text-blue-600 hover:underline">cosmino.space@gmail.com</a>
                </p>
                <p className="text-blue-800 font-medium mt-2">
                  🌐 Website: <a href="https://cosmino.space" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">cosmino.space</a>
                </p>
              </div>
            </section>

            {/* Footer */}
            <div className="border-t border-gray-200 pt-6 mt-8">
              <p className="text-sm text-gray-500 text-center">
                Last updated: October 13, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;